import LogRocket from 'logrocket';
import AuthUtils from '../../share/utils/network/AuthUtils';

// eslint-disable-next-line import/prefer-default-export
export const initApp = () => {
  if (!AuthUtils.isLocalhost()) {
    LogRocket.init('ncqptg/ark_design');
    const { attributes } = AuthUtils.getUser();
    LogRocket.identify(attributes.email, {
      email: attributes.email,
    });
  }
};
